// src/main.js
import './style.css'
import { ApiService } from './services/api.js'
import { OrgChartComponent } from './components/orgChart.js'
import { TableView } from './components/TableView.js'

class App {
    constructor() {
        this.apiService = new ApiService();
        this.orgChart = null;
        this.tableView = null;
        this.data = [];
        this.currentView = 'tree';
        
        this.init();
    }

    async init() {
        try {
            console.log('Загрузка данных иерархии...');
            
            this.showLoading();
            this.data = await this.apiService.getHierarchy();
            console.log('Данные загружены:', this.data.length, 'записей');
            
            this.initOrgChart();
            this.initTableView();
            this.setupEventListeners();
            
        } catch (error) {
            console.error('Ошибка инициализации:', error);
            this.showError('Не удалось загрузить данные иерархии');
        }
    }

    showLoading() {
        const chartContainer = document.getElementById('chart-container');
        const tableContainer = document.getElementById('table-container');
        chartContainer.innerHTML = '<div class="loading">Загрузка данных ДОНМ...</div>';
        tableContainer.innerHTML = '<div class="loading">Загрузка данных ДОНМ...</div>';
    }

    initOrgChart() {
        this.orgChart = new OrgChartComponent('#chart-container', this.data);
        if (this.currentView === 'tree') {
            this.orgChart.render();
        }
    }

    initTableView() {
        this.tableView = new TableView('#table-container', this.data);
        if (this.currentView === 'table') {
            this.tableView.render();
        }
    }

    setupEventListeners() {
        const searchInput = document.getElementById('searchInput');
        searchInput.addEventListener('input', (e) => {
            if (this.currentView === 'tree') {
                this.orgChart.search(e.target.value);
            } else {
                const filteredData = this.data.filter(employee => 
                    employee.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
                    (employee.positionname && employee.positionname.toLowerCase().includes(e.target.value.toLowerCase())) ||
                    (employee.department && employee.department.toLowerCase().includes(e.target.value.toLowerCase()))
                );
                this.tableView.updateData(filteredData);
            }
        });

        document.getElementById('expandAll').addEventListener('click', () => {
            if (this.currentView === 'tree') {
                this.orgChart.expandAll();
            }
        });

        document.getElementById('collapseAll').addEventListener('click', () => {
            if (this.currentView === 'tree') {
                this.orgChart.collapseAll();
            }
        });

        document.getElementById('resetZoom').addEventListener('click', () => {
            if (this.currentView === 'tree') {
                this.orgChart.resetZoom();
            }
        });

        document.getElementById('viewMode').addEventListener('change', (e) => {
            this.switchView(e.target.value);
        });
    }

    switchView(view) {
        this.currentView = view;
        const chartContainer = document.getElementById('chart-container');
        const tableContainer = document.getElementById('table-container');
        const expandAllBtn = document.getElementById('expandAll');
        const collapseAllBtn = document.getElementById('collapseAll');
        const resetZoomBtn = document.getElementById('resetZoom');

        if (view === 'tree') {
            chartContainer.style.display = 'block';
            tableContainer.style.display = 'none';
            expandAllBtn.style.display = 'inline-block';
            collapseAllBtn.style.display = 'inline-block';
            resetZoomBtn.style.display = 'inline-block';
            this.orgChart.render();
        } else {
            chartContainer.style.display = 'none';
            tableContainer.style.display = 'block';
            expandAllBtn.style.display = 'none';
            collapseAllBtn.style.display = 'none';
            resetZoomBtn.style.display = 'none';
            this.tableView.render();
        }
    }

    showError(message) {
        const chartContainer = document.getElementById('chart-container');
        const tableContainer = document.getElementById('table-container');
        chartContainer.innerHTML = `<div class="error">⚠️ ${message}</div>`;
        tableContainer.innerHTML = `<div class="error">⚠️ ${message}</div>`;
    }
}

new App();

if (import.meta.hot) {
    import.meta.hot.accept();
}
